import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { NzI18nModule } from '../i18n/nz-i18n.module';

import { NzButtonModule } from '../button';
import { NzMenuModule } from '../menu';
import { NzDropDownModule } from '../dropdown';
import { NzInputNumberModule } from '../input-number';

import { NzPaginationNetComponent } from './nz-pagination-net.component';

@NgModule({
  declarations: [ NzPaginationNetComponent ],
  exports     : [ NzPaginationNetComponent ],
  imports     : [ CommonModule, FormsModule, NzInputNumberModule, NzButtonModule, NzMenuModule, NzDropDownModule, NzI18nModule ]
})

export class NzPaginationNetModule {
}
